var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCustomRocket = function SvgCustomRocket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.77 15 9 12.231m2.77 2.77a20.628 20.628 0 0 0 3.691-1.847M11.77 15v4.616s2.797-.508 3.692-1.846c.998-1.496 0-4.616 0-4.616M9 12.231a20.302 20.302 0 0 1 1.846-3.646A11.888 11.888 0 0 1 21 3c0 2.511-.72 6.923-5.539 10.154M9 12.231H4.385s.507-2.797 1.846-3.692c1.495-.997 4.615 0 4.615 0m-6 7.846C3.462 17.548 3 21 3 21s3.452-.461 4.615-1.846c.656-.775.647-1.966-.083-2.686a2.012 2.012 0 0 0-2.686-.083Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgCustomRocket;